module.exports = __webpack_public_path__ + "img/bespoke123_29.da66765d.jpg";